import {action, computed, makeAutoObservable} from "mobx"
import {ChosenMenuItemModifierSet, ICartItem} from "../types/types";
import {saveStoreToLocalStorage} from "./persistence";
import {rootStore} from "./index";


class Cart {
    list: ICartItem[] = [];
    menuId: number = 0;

    constructor() {
        makeAutoObservable(this);
    }

    getExactlyTheSameEntry(cartItem: ICartItem, chosenMenuItemModifierSets: ChosenMenuItemModifierSet[]) {
        return cartItem.items.findIndex(item => {
            if (item.chosenMenuItemModifierSets.length !== chosenMenuItemModifierSets.length) {
                return false;
            }
            let result = true;
            chosenMenuItemModifierSets.forEach((set, index) => {
                const ciSet = item.chosenMenuItemModifierSets[index];
                if (ciSet.menuItemModifierSetId !== set.menuItemModifierSetId) {
                    return false
                }
                result = result && JSON.stringify(ciSet.chosenMenuItemModifiers) === JSON.stringify(set.chosenMenuItemModifiers);
            })
            return result;
        });

    }

    @action
    addItem(menuItem: any, chosenMenuItemModifierSets: ChosenMenuItemModifierSet[], count: number) {

        const item = this.list.find((item) => item.menuItemId === menuItem.id);
        // товар уже есть
        if (item) {
            const entryIndex = this.getExactlyTheSameEntry(item, chosenMenuItemModifierSets);
            if (entryIndex >= 0) {
                const entry = item.items[entryIndex];
                entry.count += count;
                item.count += count;
            } else {
                item.count += count;
                item.items.push({
                    count,
                    menuItem,
                    chosenMenuItemModifierSets
                });
            }
            saveStoreToLocalStorage();
            return;
        }

        // товара нет
        this.list.push({
            menuItemId: menuItem.id,
            count: count,
            items: [
                {
                    menuItem,
                    chosenMenuItemModifierSets,
                    count
                }
            ]
        });
        saveStoreToLocalStorage();
    }

    @action
    removeItem(menuItemId: number, options: { all: boolean, indexToRemove: number } = {
        all: false,
        indexToRemove: -1
    }) {
        const index = this.list.findIndex((item) => item.menuItemId === menuItemId);

        if (index < 0) {
            return;
        }
        const item = this.list[index];

        if (item.count > 1 && !options.all) {
            if (options.indexToRemove >= 0) {
                const entry = item.items[options.indexToRemove];
                if (entry.count === 1) {
                    item.items.splice(options.indexToRemove, 1);
                } else {
                    entry.count--;
                }
            } else {
                if (item.items[item.items.length - 1].count > 1) {
                    item.items[item.items.length - 1].count--;
                } else {
                    item.items.pop()
                }
            }

            item.count -= 1;
            saveStoreToLocalStorage();
            return;
        }
        this.list.splice(index, 1);
        saveStoreToLocalStorage();
    }

    @computed
    getDiscountAmount(discountPercent: number) {
        return this.list.reduce((memo, item) => {
            return memo + item.items.reduce((memo2, item2, index2) => {

                let itemTotal = this.getTotalByMenuItem(item2.menuItem.id, index2)

                if (![5155, 139].includes(item2.menuItem.data.menuCategoryId)) {
                    return memo2 + (itemTotal * (discountPercent / 100))
                } else {
                    return memo2
                }
            }, 0)
        }, 0)
    }

    @computed
    getTotal() {
        return this.list.reduce((memo, item) => {
            return memo + item.items.reduce((memo2, item2, index2) => {
                return memo2 + this.getTotalByMenuItem(item2.menuItem.id, index2)
            }, 0)
        }, 0)
    }

    @computed
    getTotalByMenuItem(menuItemId: number, index: number) {
        const item = this.list.find(item => item.menuItemId === menuItemId);
        if (!item) return -50000;

        const t = item.items[index];

        let pricePerItem = t.menuItem.data.sellPrice.price;

        for (let modifiersSets of t.chosenMenuItemModifierSets) {
            const set = rootStore.menuStore.getModifiersById(modifiersSets.menuItemModifierSetId);
            for (let modifier of modifiersSets.chosenMenuItemModifiers) {
                const obj = set.data.modifiers.find(item => item.id === modifier.menuItemModifierId);
                if (obj) {
                    pricePerItem += obj.data.sellPrice.price * (modifier?.count || 1)
                }
            }
        }
        return pricePerItem * t.count;
    }

    @computed
    getCartItemById(menuItemId: number) {
        return this.list.find((item) => item.menuItemId === menuItemId);
    }

    @computed
    isInCart(menuItemId: number) {
        return !!this.getCartItemById(menuItemId);
    }


    @computed
    isCartEmpty() {
        return this.list.length === 0;
    }

    @action
    setList(list: ICartItem[]) {
        this.list = list;
    }

    @action
    setMenuId(menuId: number) {

        if (this.menuId !== menuId) {
            this.setList([]);
        }
        this.menuId = menuId;
    }


    @action
    reset() {
        this.list = [];
        saveStoreToLocalStorage();
    }

    @action
    resetRegularCart() {
        this.list = [];
        saveStoreToLocalStorage();
    }

    static fromJSON(obj: any) {
        const cart = new Cart();
        cart.menuId = obj.menuId || 0;
        cart.setList(obj.list);

        return cart;
    }

    @action
    filterCart() {
        const items = rootStore.menuStore.items;

        const obj = Object.entries(items)
            .reduce((memo, entry) => {
                for (let item of entry[1]) {
                    memo[item.id] = true;
                }
                return memo;
            }, {} as { [s: string]: boolean });

        this.list = this.list.filter((item) => {
            return obj[item.menuItemId];
        });

        saveStoreToLocalStorage()
    }


}


export default Cart
